import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Reviews from "./components/Reviews";
import Quote from "./components/Quote";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import FloatingCTAs from "./components/FloatingCTAs";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./components/NotFound";

function HomePage() {
  return (
    <div data-testid="home-page" className="bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Gallery />
        <Reviews />
        <Quote />
        <Contact />
      </main>
      <Footer />
      <FloatingCTAs />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </ErrorBoundary>
    </div>
  );
}

export default App;
